import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import profileImg from "../../assets/globalImgs/profile.png";
import axios from "axios";
import useHandleErrors from "../../utils/user.utils";
import { ToastContainer, toast } from "react-toastify";
import Select from 'react-select';


export default function Settlement() {
    const [employeeData, setEmployeeData] = useState({});
    const [loading, setLoading] = useState(false);
    const [finalSettlement, setFinalSettlement] = useState('');
    const [status, setStatus] = useState('');
    const [rating, setRating] = useState(0);
    const [comments, setComments] = useState('');
    const [relievingLetter, setRelievingLetter] = useState(null);
    const [relievingName, setRelievingName] = useState('');
    const [experienceLetterName, setExperienceLetterName] = useState('');
    const [experienceLetter, setExperienceLetter] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const navigate = useNavigate();
    const handleErrors = useHandleErrors();
    const Skipped = localStorage.getItem("Skipped");
    console.log("Skipped", Skipped)

    const empId = localStorage.getItem("empId")
    console.log("empId", empId)
    const token = localStorage.getItem("token");
    const hasFetchedRef = useRef(false);

    const fetchEmployeeData = async () => {
        if (empId) {
            setLoading(true);
            try {
                const path = `/getOnboardEmployeeDetails?EmployeeId=${empId}`;
                const URL = process.env.REACT_APP_BE_URL + path;
                const response = await axios.get(URL, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                if (response.status === 200) {
                    setEmployeeData(response.data);
                }
                else {
                    handleErrors(response)
                }
            } catch (error) {
                if (error.response) {
                    handleErrors(error.response);
                } else {
                    toast.error("Something went wrong. Please try again later.", {
                        position: toast.POSITION.TOP_CENTER,
                    });
                }
            } finally {
                setLoading(false);
            }
        }
    };

    useEffect(() => {
        if (!hasFetchedRef.current) {
            fetchEmployeeData();
            hasFetchedRef.current = true;
        }
    }, [empId]);

    useEffect(() => {
        const preloading = document.getElementById("preloading");
        setTimeout(() => {
            if (preloading) {
                preloading.style.display = "none";
            }
        }, 400);
    }, []);

    const handleSettlementChange = (selectedOption) => {
        setFinalSettlement(selectedOption ? selectedOption.value : '');
        // const value = e.target.value;
        // setFinalSettlement(value);
    };

    const handleRatingChange = (e) => {
        const value = parseInt(e.target.value);
        setRating(value);
    };

    const handleCommentsChange = (e) => {
        const value = e.target.value;
        setComments(value);
    };

    const handleRelievingLetterChange = (e) => {
        const file = e.target.files[0];
        setRelievingLetter(file);
        setRelievingName(file.name);
    };

    const handleExperienceLetterChange = (e) => {
        const file = e.target.files[0];
        setExperienceLetter(file);
        setExperienceLetterName(file.name)
    };

    const handleSubmit = async (event) => {
        event.preventDefault();
        setLoading(true);
        try {
            const path = "/updateOffboardEmployee";
            const URL = process.env.REACT_APP_BE_URL + path;
            const payload = {
                EmployeeId: employeeData?.EmployeeId,
                EmployerRating: rating,
                FinalSettlement: finalSettlement,
                Status: finalSettlement === "Yes" ? "Settled" : "Relieved",
                Comments: comments,
                UpdatedBy: employeeData?.FirstName,
                RelievingLetter: relievingLetter,
                ExperienceLetter: experienceLetter,
                ActiveFlag: "N",
            };
            const response = await axios.put(URL, payload, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });
            if (response.status === 200) {
                localStorage.removeItem('empId', empId);
                // toast.success("Settlement Done!", {
                //     position: toast.POSITION.TOP_CENTER,
                // });
                setShowModal(true);
            } else {
                handleErrors(response);
            }
        } catch (error) {
            if (error.response) {
                handleErrors(error.response);
            } else {
                toast.error("Something went wrong. Please try again later.", {
                    position: toast.POSITION.TOP_CENTER,
                });
            }
        } finally {
            setLoading(false);
        }
    };

    const handleCloseModal = () => {
        setShowModal(false);
        localStorage.removeItem('empId');
        navigate('/home');

    };

    const handlePrevious = () => {
        localStorage.removeItem("Skipped");
        navigate("/assethandover")
    };

    const handleReset = () => {
        setFinalSettlement('')
        setComments('')
        setRating(0)
        setStatus('')
        setRelievingLetter(null)
        setExperienceLetterName('')
        setRelievingName('')
        setExperienceLetter(null)
    };

    const settlementOptions = [
        { value: "Yes", label: "Yes" },
        { value: "No", label: "No" }
    ];

    const ClearIndicator = () => null;
    return (
        <div>
            {loading && (
                <div id="preloading">
                    <span className="loader"></span>
                </div>
            )}
            <ToastContainer />
            <div class="content-page">
                <div class="container-fluid">
                    <div class="row mb-2">
                        <div class="col">
                            <h3 class="title mb-2">Offboard Employee</h3>
                        </div>
                        <div class="col-auto">
                            <a
                                href={"/Employees"}
                                data-extra-toggle="tab"
                                data-target="#organisation-pan"
                                class="btn btn-primary mt-lg-0 mt-4"
                            >
                                <i class="ri-user-star-line"></i> View All Employees
                            </a>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-1">
                            <div class="circle-tab-wrapper">
                                <ul class="nav nav-tabs circle-tab" role="tablist">
                                    <li class="nav-item step-done">
                                        <a
                                            class="nav-link"
                                            data-toggle="tab"
                                            title="Employee Information"
                                            rel="tooltip"
                                            role="tab"
                                            onClick={(e) => e.preventDefault()}
                                        >
                                            <i class="ri-user-received-line"></i>
                                        </a>
                                    </li>
                                    <li class="nav-item step-done">
                                        <a
                                            class="nav-link"
                                            data-toggle="tab"
                                            title="Asset Handover"
                                            rel="tooltip"
                                            role="tab"
                                            onClick={(e) => e.preventDefault()}
                                        >
                                            <i class="ri-hand-coin-line"></i>
                                        </a>
                                    </li>
                                    <li class="nav-item step-done">
                                        <a
                                            class="nav-link active"
                                            data-toggle="tab"
                                            title="Settlement"
                                            rel="tooltip"
                                            role="tab"
                                            onClick={(e) => e.preventDefault()}
                                        >
                                            <i class="ri-shake-hands-line"></i>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-lg-11">
                            <div class="tab-pane" id="settlement" role="tabpanel">
                                <div class="row">
                                    <div class="col-lg-4">
                                        <div class="card mb-4">
                                            <div class="card-body">
                                                <h5 class="title">Employee Information</h5>
                                                <div class="container-fluid row-rounded">
                                                    <div class="row px-2 py-0">
                                                        <div class="input-group mb-0">
                                                            <input
                                                                type="search"
                                                                class="form-control search-input"
                                                                value={empId}
                                                                disabled
                                                            />
                                                            <div class="input-group-append">
                                                                <button
                                                                    class="btn btn-primary"
                                                                    type="button"
                                                                    title="Search"
                                                                    rel="tooltip"
                                                                >
                                                                    <i class="ri-user-search-line"></i>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                {employeeData && (
                                                    <div class="user-info">
                                                        <div class="profile-detail">
                                                            <div class="user-profile-pic">
                                                                <img src={employeeData?.Image ? employeeData?.Image : profileImg} class="img-fluid" />
                                                            </div>
                                                        </div>
                                                        <div class="text-center mt-3 mb-4">
                                                            <h6>{employeeData?.FirstName} {employeeData?.MiddleName} {employeeData?.LastName}</h6>
                                                        </div>
                                                    </div>
                                                )}
                                                <div class="row mt-3">
                                                    <div class="form-group col-md-6 col-lg-12 col-sm-6">
                                                        <small class="form-text text-muted mb-2" for="oeEmail">Official Email</small>
                                                        <h6>{employeeData?.OfficialEmail}</h6>
                                                    </div>
                                                    <div class="form-group col-md-6 col-lg-12 col-sm-6">
                                                        <small class="form-text text-muted mb-2" for="oeEmail">Personal Email</small>
                                                        <h6>{employeeData?.PersonalEmail}</h6>
                                                    </div>
                                                    <div class="form-group col-md-6 col-lg-12  col-sm-6">
                                                        <small class="form-text text-muted mb-2" for="contactNumber">Contact Number</small>
                                                        <h6>{employeeData?.ContactNumber}</h6>
                                                    </div>
                                                    <div class="form-group col-md-6 col-lg-6 col-sm-6">
                                                        <small class="form-text text-muted mb-2" for="userAccess">User Access</small>
                                                        <h6>{employeeData?.UserAccessLevel}</h6>
                                                    </div>
                                                    <div class="form-group col-md-6 col-lg-6 col-sm-6">
                                                        <small class="form-text text-muted mb-2" sm for="employeeType">Employment Type</small>
                                                        <h6>{employeeData?.EmployeeType}</h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-8">
                                        <div className="card mb-4">
                                            <div className="card-body">
                                                <h5 className="title">Settlement Information</h5>
                                                <div className="row mt-4">
                                                    <div className="col-md-6">
                                                        <div className="row">
                                                            <div className="form-group col-md-12">
                                                                <label htmlFor="useraccess">
                                                                    Full & Final Settlement
                                                                </label>
                                                                <Select
                                                                    className="react-select-container"
                                                                    classNamePrefix="react-select"
                                                                    name="finalSettlement"
                                                                    value={settlementOptions.find(option => option.value === finalSettlement) || null}
                                                                    onChange={handleSettlementChange}
                                                                    options={settlementOptions}
                                                                    components={{ ClearIndicator }}
                                                                    isClearable
                                                                    menuPortalTarget={document.body}
                                                                />
                                                            </div>
                                                            <div className="form-group col-md-12">
                                                                <label htmlFor="useraccess">Employer Rating</label>
                                                                <div className="stars">
                                                                    <span className="rate-num">1 - 5</span>
                                                                    {[...Array(5)].map((_, index) => (
                                                                        <React.Fragment key={index}>
                                                                            <input
                                                                                type="radio"
                                                                                id={`star-${index + 1}`}
                                                                                className={`star star-${index + 1}`}
                                                                                name="rating"
                                                                                value={index + 1}
                                                                                onChange={handleRatingChange}
                                                                            />
                                                                            <label
                                                                                className={`star star-${index + 1}`}
                                                                                htmlFor={`star-${index + 1}`}
                                                                            ></label>
                                                                        </React.Fragment>
                                                                    ))}
                                                                    <div className="comment-box">
                                                                        <textarea
                                                                            className="form-control comment"
                                                                            col="30"
                                                                            name="comments"
                                                                            value={comments}
                                                                            placeholder="Comments"
                                                                            onChange={handleCommentsChange}
                                                                        ></textarea>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6">
                                                        <div className="text-center">Status</div>
                                                        <div className="row mt-3">
                                                            <div className="col-6 text-center border-right">
                                                                <div
                                                                    className={`status-icon-box relived ${finalSettlement === 'No' ? 'done' : ''}`}
                                                                    onClick={() => setStatus('Relived')}
                                                                >
                                                                    <i className="ri-shake-hands-fill"></i>
                                                                </div>
                                                                <small className="form-text text-muted">
                                                                    Relieved
                                                                </small>
                                                            </div>
                                                            <div className="col-6 text-center border-left">
                                                                <div
                                                                    className={`status-icon-box settled ${finalSettlement === 'Yes' ? 'done' : ''}`}
                                                                    onClick={() => setStatus('Settled')}
                                                                >
                                                                    <i className="ri-walk-fill"></i>
                                                                </div>
                                                                <small className="form-text text-muted">
                                                                    Settled
                                                                </small>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <hr />
                                                <h5 className="title">Basic Information</h5>
                                                <div className={`row mt-4 ${finalSettlement === 'No' ? 'disabled' : ''}`}>
                                                    <div className="col-12">
                                                        <div className="row">
                                                            <div className="form-group col-md-6">
                                                                <label htmlFor="username">
                                                                    Relieving Letter
                                                                </label>
                                                                <div className="input-group">
                                                                    <div className="custom-file">
                                                                        <input
                                                                            type="file"
                                                                            className="custom-file-input"
                                                                            id="relievingLetter"
                                                                            // disabled={finalSettlement === 'No'}
                                                                            onChange={handleRelievingLetterChange}
                                                                        />
                                                                        <label
                                                                            className="custom-file-label"
                                                                            htmlFor="relievingLetter"
                                                                        >
                                                                            {relievingName}
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="form-group col-md-6">
                                                                <label htmlFor="username">
                                                                    Experience Letter
                                                                </label>
                                                                <div className="input-group">
                                                                    <div className="custom-file">
                                                                        <input
                                                                            type="file"
                                                                            className="custom-file-input"
                                                                            id="experienceLetter"
                                                                            // disabled={finalSettlement === 'No'}
                                                                            onChange={handleExperienceLetterChange}
                                                                        />
                                                                        <label
                                                                            className="custom-file-label"
                                                                            htmlFor="experienceLetter"
                                                                        >
                                                                            {experienceLetterName}
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="row fixed-footer">
                <div class="col-lg-12 text-center OFFBthirdTab">
                    {Skipped === "Skipped" && (
                        <button
                            className="btn btn-light btnPrevious"
                            type="button"
                            onClick={handlePrevious}
                        >
                            <i className="ri-arrow-left-circle-line"></i> Previous
                        </button>
                    )}
                    <button class="btn btn-light btnPrevious" type="button" onClick={handleReset}>Reset</button>
                    <button class="btn btn-primary btnNext" type="button" onClick={handleSubmit}>Submit <i class="ri-checkbox-circle-line"></i></button>
                </div>
            </div>
            {showModal && (
                <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-labelledby="successModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-sm modal-dialog-centered" role="document">
                        <div className="modal-content shadow success-modal">
                            <div className="modal-header py-2">
                                <h6 className="modal-title" id="successModalModalLabel">Success!</h6>
                                <button className="close" type="button" aria-label="Close" onClick={handleCloseModal}>
                                    <span aria-hidden="true"><i className="ri-close-circle-fill font-size-20"></i></span>
                                </button>
                            </div>
                            <div className="modal-body pb-5">
                                <div className="row">
                                    <div className="col-12 text-success text-center"><i className="ri-checkbox-circle-fill"></i></div>
                                    <div className="col-12 text-center">Offboarded Successfully.</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}

        </div>
    );
}
